import { StandardTag, isStandardTag } from "@aidkitorg/types/lib/tags";
import { useLocalizedStrings } from "../Localization";
import { useContext, useMemo } from "react";
import InterfaceContext, { PublicConfigurationContext } from "../Context";
import { Badge, Tooltip } from "@aidkitorg/component-library";

export const useTagDetails = (possibleTag: StandardTag | string) => {
  const L = useLocalizedStrings();
  const configContext = useContext(PublicConfigurationContext);
  const userManagementConfig = configContext?.experimental?.userManagementConfig;
  const interfaceContext = useContext(InterfaceContext);
  const lang = interfaceContext.lang;
  
  const tagDetails = useMemo(() => {
    const customTag = userManagementConfig?.customTags?.find(t => t.tag === possibleTag);
    if (customTag) {
      return { name: customTag.name[lang], description: customTag.description[lang] };
    }

    const tag = isStandardTag(possibleTag) ? possibleTag : undefined;
    
    return {
      name: tag ? L.permissions[tag].name : possibleTag,
      description: tag ? L.permissions[tag].description : possibleTag
    }
  }, [possibleTag, configContext, L.permissions, interfaceContext, userManagementConfig]);

  return tagDetails;
}

export const TagBadge = ({ tag }: { tag: StandardTag | string }) => {
  const tagDetails = useTagDetails(tag);
  return <Tooltip text={tagDetails.description} asChild={true}>
    <span>
      <Badge key={tag} variant="neutral">{tagDetails.name}</Badge>
    </span>
  </Tooltip>
}